/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.branding.importBundle";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"broadcaster":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"merge":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false)),"dryRun":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false))});

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.payload("application/zip");

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"applied":/*#__PURE__*/ l.boolean(),"changes":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Change>((() => change) as any), ),"warnings":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), ))});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Apply a branding bundle (see exportBundle). By default the bundle replaces the node's branding: keys it does not mention are removed. Every value is validated like updateBlob. Requires admin authorization. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized","InvalidBundle"]);

export { main };

export const $lxm = $nsid;

type Change = { $type?: "place.stream.branding.importBundle#change";"key":string;"action":"added" | "changed" | "removed" | "unchanged" | l.UnknownString;

  /**
   * The new text value, or the image's type and size.
   */
  "detail"?:string };

export type { Change };

const change = /*#__PURE__*/ l.typedObject<Change>($nsid, "change", /*#__PURE__*/ l.object({"key":/*#__PURE__*/ l.string(),"action":/*#__PURE__*/ l.string<{"knownValues":["added","changed","removed","unchanged"]}>(),"detail":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())}));

export { change };
